<template>
    <span class="truncate">
        {{ params.data.accountName }}
    </span>
</template>
<script>
export default {}
</script>

<style>
.ag-cell-wrapper {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}
</style>